<template>
    <div class="mainpage">
        <h2>inventory count</h2>

        <div class="home">
            <div class="form" v-if="!selectedWaveID">
                <div>Select your active Inventory Wave:</div>
                <select v-model="tmpselectedWaveID" class="sel">
                    <option value="0"> - please select -</option>
                    <option v-for="wv in activeInvenWaves" :value="wv.iwaveID">{{ wv.description }} (ID:{{ wv.iwaveID}})</option>
                </select>
            </div>
            <div v-else class="c">
                <div class="flx" @click="invalidateWave">
                    <refresh-icon/>
                </div>
                Current Inventory Wave: <b>{{ selectedWaveDescription }}</b> (ID: {{ selectedWaveID }})
            </div>
        </div>

        <div class="home" v-if="selectedWaveID">
            <div class="form">
                <div>SN/IC:</div>
                <input v-if="!checkedIC" ref="snfld" type="text" v-model="tmpSN" class="inp big"
                       @keypress.enter="scanSN"/>
                <div v-else><b>{{ checkedIC.itemCode }}</b> :: {{ checkedIC.itemDescr }}</div>
            </div>
            <div class="c" v-if="already"><b>{{ already.iC }}</b> :: totally scanned: <b>{{ already.already }}</b></div>
        </div>
        <div class="home" v-if="checkedIC">
            <div class="form" style="justify-content: center">
                <div>Quantity:</div>
                <input type="number" min="1" ref="quantity" v-model="tmpQ" autofocus @keypress.enter="scanSN" required="required"
                       @click="$refs.quantity.select()" class="inp megabig c" style="max-width: 150px">
                <div style="width: 10px"></div>
                <button class="inp big" :class="{ 'defcolor': tmpQ>0 }" style="padding: 14px; width: 100px" @click="scanSN">OK</button>
            </div>
        </div>

        <div class="home" v-if="inventorySNs.length">
            <!--<div class="flx" @click="clear_sns">
                <del-icon/>
            </div>-->
            <h4>Scanned items:</h4>
            <ul class="snlist">
                <li v-for="sn in inventorySNs.slice().reverse()"
                    :class="{ 'notfound': sn.icon == 0, 'ok': sn.icon == 1, 'okbut': sn.icon==2, 'dupl': sn.icon == 4 }"><span
                        v-text="sn.validSN" class="sn"></span>
                    <span class="ponum" v-text="sn.iC"></span>
                    <span class="status" v-text="sn.status"></span>
                </li>
            </ul>
        </div>

        <div class="overlay" v-if="loading"></div>
        <div class="loading" v-if="loading">
            <sync-icon style="font-size: 80px; color: white"/>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import debounce from '@/debounce';
    import {mapState, mapGetters} from 'vuex'
    import RefreshIcon from "vue-material-design-icons/refresh"
    import DelIcon from "vue-material-design-icons/delete-circle"
    import SyncIcon from "vue-material-design-icons/sync"


    export default {
        name: "Inventory",
        components: {
            RefreshIcon, DelIcon, SyncIcon
        },
        computed: {
            ...mapState(['validWorker', 'checkedIC', 'loading', 'lastResult', 'inventorySNs','already',
                'selectedWaveID','activeInvenWaves']),
            ...mapGetters(['actField']),
            selectedWaveDescription() {
                return this.activeInvenWaves.find(i => i.iwaveID == this.selectedWaveID).description;
            }
        },
        data() {
            return {
                wrkr: '',
                tmpSN: '',
                tmpQ: '',
                waitingForQ: false,
                tmpselectedWaveID: 0,
            }
        },
        watch: {
            lastResult: function () {
                this.$toasted.show(this.lastResult.msg, {
                    theme: "toasted-primary",
                    position: "top-center",
                    fullWidth: true,
                    duration: 4000,
                    type: this.lastResult.type
                });
            },
            actField: function(f) {
                Vue.nextTick(() => {
                    if (this.$refs[f]) this.$refs[f].focus();
                });
            },
            tmpselectedWaveID: function(wid) {
                if (wid>0)
                    this.$store.commit('saveIWave', wid);
            }
        },
        mounted() {
            if (this.$refs.snfld) this.$refs.snfld.focus();
            this.$store.dispatch('invenActiveWaves');
        },
        methods: {
            invalidateWave() {
                this.$store.commit('saveIWave',null);
            },
            scanSN: function () {
                if (this.checkedIC) {
                    this.$store.dispatch('invenScanBarcode', {'ic': this.checkedIC.itemCode, 'q': this.tmpQ, iwaveID: this.selectedWaveID});
                    this.tmpQ = '';
                    return;
                }

                if (this.tmpSN.trim().length > 4) {
                    this.$store.dispatch('invenScanBarcode', {'bc': this.tmpSN, iwaveID: this.selectedWaveID});
                    this.tmpSN = '';
                }
            },
        }
    }
</script>

<style scoped>
    .inp {
    }

    .form {
        display: flex;
        clear: both;
        align-items: center;
    }

    .form > DIV {
        white-space: nowrap;
        margin: 5px 7px 5px 0;
    }
    .msg {
        text-align: center
    }

    h4 {
        margin: 0
    }



    .flx {
        float: right;
        font-size: 20px;
        margin: -5px 5px;
    }

    .snlist {
        padding: 0;
        margin: 10px 0;
        list-style-type: none
    }

    .snlist LI {
        margin: 0px;
        padding: 1px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: solid 1px #ccc
    }

    .snlist .sn {
        flex: 1 1;
        padding-right: 4px;
    }

    .snlist li:before {
        content: '..';
        padding: 1px 0;
        color: white;
        background-color: deepskyblue;
        margin-right: 6px;
        border-radius: 4px;
        text-align: center;
        min-width: 22px;
    }

    .snlist li.ok:before {
        content: '✓';
        background-color: green;
    }

    .snlist li.okbut:before {
        content: '?';
        background-color: lightseagreen;
    }

    .snlist li.notfound:before {
        content: '⨉';
        font-weight: bold;
        background-color: red;
        line-height: 17px;
    }

    .snlist li.dupl:before {
        content: '‼';
        font-weight: bold;
        background-color: orange;
    }

    .ponum {
        border-left: solid 1px #999;
        padding: 0 2px 0 5px;
        flex: 2 1;
    }

    .status {
        border-left: solid 1px #999;
        padding: 0 2px;
        flex: 1 1;
        text-align: right;
        font-size: 11px;
    }

    @media (max-width: 400px) {
        .status {
            display: none;
        }
    }

    select.sel {
        -webkit-appearance: button;
        -webkit-padding-end: 20px;
        -webkit-padding-start: 2px;
        -webkit-user-select: none;
        border: 1px solid #AAA;
        border-radius: 5px;
        color: #333;
        font-size: inherit;
        margin: 5px 0;
        padding: 10px;
        background-color: white;
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
        width: 100%;
    }
</style>